import { IInstallmentItem } from "models";

export const defineMaxInstallments = (installments: IInstallmentItem[]) => {
  return installments.sort((a, b) => a.installment_number - b.installment_number)[installments.length - 1];
};
